import { render, staticRenderFns } from "./pack.vue?vue&type=template&id=3fdc1cc1&scoped=true&"
import script from "./pack.vue?vue&type=script&lang=js&"
export * from "./pack.vue?vue&type=script&lang=js&"
import style0 from "./pack.vue?vue&type=style&index=0&id=3fdc1cc1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdc1cc1",
  null
  
)

export default component.exports